"use client";
import React, { useState } from "react";

const Technical = () => {
  const [moneyBtnSelection, setMoneyBtnSelection] = useState("In the Money");
  const handleDocumentsClick = (moneyBtn) => {
    setMoneyBtnSelection(moneyBtn);
  };

  return (
    <div className="m-4">
      <p className="font-bold text-2xl text-[#333333] mb-6">Technical</p>
      <div className="flex gap-4">
        <div>
          <div className="border border-solid border-[#E0E0E0] rounded-lg p-4 flex flex-col gap-3 w-[393px] h-[109px]">
            <div className="flex justify-between">
              <p className="font-semibold text-sm text-[#333333]">
                Traded Quantity 
              </p>
              <img src="/images/infoLogo.png" alt="" className="w-4 h-4" />
            </div>
            <div>
              <p className="font-semibold text-xs mb-2 text-[#00394d]">13.7M</p>
              <div className="flex justify-between">
                <p className="font-medium text-xs text-[#555555]">
                  . NSE+BSE Volume{" "}
                </p>
                <p className="font-medium text-xs text-[#555555]">
                  . 10 May,2024 3:20 PM (IST)
                </p>
              </div>
            </div>
          </div>
          <div className="border border-solid mt-4 border-[#E0E0E0] rounded-lg p-4 flex flex-col gap-3 w-[393px] h-[281px]">
            <p className="text-sm font-semibold text-[#333333]">
              Indicators Value
            </p>
            <div className="w-[361px] h-[220px] flex gap-[54px]">
              <div>
                <div className="flex flex-col w-[153px] h-[106px]  p-4 ">
                  <div className="flex gap-3">
                    <p className="font-bold text-xs text-[#262626] mb-4">RSI</p>
                    <img
                      src="/images/infoLogo.png"
                      alt=""
                      className="w-4 h-4"
                    />
                  </div>
                  <p className="font-semibold text-lg text-[#00394d] mb-2">
                    36.4
                  </p>
                  <p className="font-medium text-[10px] text-[#DBA12C] mb-[12px]">
                    RSI is mid-range
                  </p>
                </div>
                <div className="flex flex-col w-[153px] h-[106px]  p-4 ">
                  <div className="flex gap-3">
                    <p className="font-bold text-xs text-[#262626] mb-4">
                      50Day SMA
                    </p>
                    <img
                      src="/images/infoLogo.png"
                      alt=""
                      className="w-4 h-4"
                    />
                  </div>
                  <p className="font-semibold text-lg text-[#00394d] mb-2">
                    1475.8
                  </p>
                  <p className="font-medium text-[10px] text-[#D30D00] mb-[12px]">
                    Price below SMA-50
                  </p>
                </div>
              </div>
              <div>
                <div className="flex flex-col w-[153px] h-[106px]  p-4 ">
                  <div className="flex gap-3">
                    <p className="font-bold text-xs text-[#262626] mb-4">
                      Beta 1 Year
                    </p>
                    <img
                      src="/images/infoLogo.png"
                      alt=""
                      className="w-4 h-4"
                    />
                  </div>
                  <p className="font-semibold text-lg text-[#00394d] mb-2">
                    0.8
                  </p>
                  <p className="font-medium text-[10px] text-[#12AC21] mb-[12px]">
                    Low volatility{" "}
                  </p>
                </div>
                <div className="flex flex-col w-[153px] h-[106px]  p-4 ">
                  <div className="flex gap-3">
                    <p className="font-bold text-xs text-[#262626] mb-4">
                      200Day SMA
                    </p>
                    <img
                      src="/images/infoLogo.png"
                      alt=""
                      className="w-4 h-4"
                    />
                  </div>
                  <p className="font-semibold text-lg text-[#00394d] mb-2">
                    1542.2
                  </p>
                  <p className="font-medium text-[10px] text-[#D30D00] mb-[12px]">
                    Price below SMA-200
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="border border-solid border-[#E0E0E0] rounded-lg p-4 flex flex-col gap-3 w-[393px]">
          <p className="font-semibold text-sm text-[#262626]">Open Interest</p>
          <p className="font-semibold text-xs text-[#262626]">May Options</p>
          <div className="border-b border-[#C3D5DC]"></div>
          <div className="flex justify-between">
            <div>
              <p className="text-xs font-medium text-[#8B8B8B]">
                At the Money IV
              </p>
              <p className="text-lg font-semibold text-[#00394d]">20.93</p>
            </div>
            <div>
              <p className="text-xs font-medium text-[#8B8B8B]">IV Change %</p>
              <p className="text-lg font-semibold text-[#D30D00]">-17.06%</p>
            </div>
          </div>
          <div className="flex justify-between mt-3">
            <div>
              <p className="text-xs font-medium text-[#8B8B8B]">
                Days for Expiry
              </p>
              <p className="text-lg font-semibold text-[#333333]">21</p>
            </div>
            <div>
              <p className="text-xs font-medium text-[#8B8B8B]">Expiry</p>
              <p className="text-lg font-semibold text-[#333333]">30 May</p>
            </div>
          </div>
          <div className="flex justify-between mt-3">
            <div>
              <p className="text-xs font-medium text-[#8B8B8B]">Market Lot</p>
              <p className="text-lg font-semibold text-[#333333]">550</p>
            </div>
            <div>
              <p className="text-xs font-medium text-[#8B8B8B]">PCR</p>
              <p className="text-lg font-semibold text-[#333333]">0.54</p>
            </div>
          </div>
          <div className="border-b border-[#C3D5DC]"></div>
          <div className="flex justify-center items-center">
            <div className="flex justify-between items-center mt-4 rounded-full w-[60%] bg-[#F1F1F6]">
              <button
                className={`text-xs font-bold px-2 py-1 text-[#848484] ${
                  moneyBtnSelection === "In the Money"
                    ? "bg-[#A0FF77] !text-[#262626] rounded-full m-0.5 py-1"
                    : ""
                }`}
                onClick={() => handleDocumentsClick("In the Money")}
              >
                In the Money
              </button>
              <button
                className={`text-xs font-bold px-2 py-1 text-[#848484] ${
                  moneyBtnSelection === "Out the Money"
                    ? "bg-[#A0FF77] !text-[#262626] rounded-full m-0.5 py-1"
                    : ""
                }`}
                onClick={() => handleDocumentsClick("Out the Money")}
              >
                Out the Money
              </button>
            </div>
          </div>
          {moneyBtnSelection === "In the Money" ? (
            <>
              <div className="flex justify-between">
                <div>
                  <p className="text-xs font-medium text-[#8B8B8B]">
                    Open Interest (OI)
                  </p>
                  <p className="text-xs font-bold text-[#333333]">
                    2,13,22,244
                  </p>
                </div>
                <div>
                  <p className="text-xs font-medium text-[#8B8B8B]">
                    Change in OI
                  </p>
                  <p className="text-xs font-bold text-[#333333]">8,28,850</p>
                </div>
              </div>
              <div className="flex justify-between">
                <div>
                  <p className="text-xs font-medium text-[#8B8B8B]">
                    OI Change %
                  </p>
                  <p className="text-xs font-bold text-[#12AC21]">4.04 %</p>
                </div>
                <div>
                  <p className="text-xs font-medium text-[#8B8B8B]">
                    Total Volume
                  </p>
                  <p className="text-xs font-bold text-[#333333]">
                    1,46,26,150
                  </p>
                </div>
              </div>
            </>
          ) : moneyBtnSelection === "Out the Money" ? (
            <>
              <div className="flex justify-between">
                <div>
                  <p className="text-xs font-medium text-[#8B8B8B]">
                    Open Interest (OI)
                  </p>
                  <p className="text-xs font-bold text-[#333333]">
                    1,13,22,244
                  </p>
                </div>
                <div>
                  <p className="text-xs font-medium text-[#8B8B8B]">
                    Change in OI
                  </p>
                  <p className="text-xs font-bold text-[#333333]">6,28,850</p>
                </div>
              </div>
              <div className="flex justify-between">
                <div>
                  <p className="text-xs font-medium text-[#8B8B8B]">
                    OI Change %
                  </p>
                  <p className="text-xs font-bold text-[#12AC21]">2.04 %</p>
                </div>
                <div>
                  <p className="text-xs font-medium text-[#8B8B8B]">
                    Total Volume
                  </p>
                  <p className="text-xs font-bold text-[#333333]">
                    1,00,26,150
                  </p>
                </div>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Technical;
